export default __webpack_public_path__ + "static/media/kw.c80fc893.png";